import { apiClient } from '@/lib/api-client'

export interface Agent {
  id: string
  name: string
  description: string
  version: string
  config: Record<string, any>
  org_id?: string
  status: 'draft' | 'published' | 'deprecated'
  created_by: string
  approved_by?: string
  approved_at?: string
  usage_count: number
  tags: string[]
  is_public: boolean
  created_at: string
  updated_at: string
  // Enriched fields from backend
  authorEmail?: string
  tenantName?: string
  organizationName?: string
  author?: string
}

export interface AgentCreateRequest {
  name: string
  description: string
  config: Record<string, any>
  tags?: string[]
  is_public?: boolean
}

export interface AgentUpdateRequest {
  name?: string
  description?: string
  config?: Record<string, any>
  tags?: string[]
  is_public?: boolean
  status?: 'draft' | 'published' | 'deprecated'
}

export interface AgentsListParams {
  page?: number
  limit?: number
  search?: string
  tenant_id?: string
  organization_id?: string
  status?: string
  is_public?: boolean
}

export interface AgentsListResponse {
  data: Agent[]
  total: number
  page: number
  limit: number
  totalPages: number
}

export const agentsApi = {
  list: (params?: AgentsListParams) =>
    apiClient.get<{ success: boolean; data: Agent[]; total: number; page: number; limit: number; totalPages: number }>('/v1/agents', { params }),
  
  create: (data: AgentCreateRequest) =>
    apiClient.post<{ success: boolean; data: Agent }>('/v1/agents', data),

  get: (id: string) =>
    apiClient.get<{ success: boolean; data: Agent }>(`/v1/agents/${id}`),
  
  update: (id: string, data: AgentUpdateRequest) => 
    apiClient.patch<Agent>(`/v1/agents/${id}`, data),
  
  delete: (id: string) => 
    apiClient.delete(`/v1/agents/${id}`),
  
  approve: (id: string) => 
    apiClient.post(`/v1/agents/${id}/approve`),
}

// Convenience functions
export const getAgents = (params?: AgentsListParams) => agentsApi.list(params)
export const getAgent = (id: string) => agentsApi.get(id)
export const createAgent = (data: AgentCreateRequest) => agentsApi.create(data)
export const updateAgent = (id: string, data: AgentUpdateRequest) => agentsApi.update(id, data)
export const deleteAgent = (id: string) => agentsApi.delete(id)
export const approveAgent = (id: string) => agentsApi.approve(id)
